<template>
<div  class="modal show_modal"    tabindex="-1"  role="dialog" >
      <div class="modal-dialog modal-lg-custom modal-dialog-centered">
        <div class="modal-content" > 
          <div class="modal-header noprint bg0 " style="border-bottom: 1px dotted #212529;">
            <div class="container">
              <button
                type="button" style="position: absolute;"
                @click="close()"
                class="btn btn-small"
              >
                <v-icon class="">mdi-arrow-left</v-icon> {{ $t("Back") }}
              </button> 
              <div class="text-center">
                     <button @click="print()" class="btn btn-print btn-brand">{{ $t('Print') }}</button>
              </div>
             </div>
          </div>
          
          <div class="modal-body" style="height: auto;padding: 0; margin-top: -1px" id="scrollableDiv">
            <div class="container visible-print" >
              <div class="row justify-content-md-center ">
                       <preview-invoice :order="order" ></preview-invoice>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: 'BaseModalPrintView',
    props: {
        order: Object,
    },
    methods:{
        async close() {
            return this.$emit("input", false);
        },
        print(){
            window.print();
        }
    }
}
</script>